import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const WarnignModal = ({ handleClose, open, from }) => {

    const navigate = useNavigate();

    const handleGoBack = () => {
        handleClose();
        if (from === "ParentOrganizationForm") {
            navigate("/admin/GroupCompanies")
        } else if (from === "Branches") {
            navigate("/admin/Branches")
        }
    }


    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Are You Sure You Want To Cancel ?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        You are about to leave this page. Any unsaved changes will be lost. Are you sure you want to go back to the previous page?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="error" variant="outlined" onClick={handleClose}>Discard</Button>
                    <Button onClick={handleGoBack} color='success' variant='contained' autoFocus>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default WarnignModal